<template>
  <b-card
    no-body
    v-draggable
    ref="marktplaats_subcard"
    id="marktplaats-subcard"
  >
    <!-- Header -->
    <b-card-header
      style="color: lightgrey; height: 25px; cursor: move"
      class="pl-2 pb-0 pt-0"
      header-tag="div"
      header-bg-variant="dark"
    >
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          Marktplaats
          <span v-if="isCompetitor"
            >-
            {{ $t("Webportal.CX.Dashboard.Exploration.Competitor") }}</span
          >
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon
            class="mx-1 clickable"
            :icon="['far', 'times']"
            @click="close()"
          />
        </b-col>
      </b-row>
    </b-card-header>

    <!-- Content -->
    <div v-if="isLoading" :class="{ spinner: isLoading }" style="height:200px"></div>
    <b-card-text
      v-else-if="MarktplaatsData != null" 
      class="pl-3 pr-3" 
      style="max-height: 500px; overflow: auto"
    >
      <!-- Top menu -->
      <b-row>
        <b-col cols="11" class="subcard-title mb-3">
          {{ headLine || MarktplaatsData.Name }}
        </b-col>
      </b-row>
      
      <b-button-group v-if="!isCompetitor">
        <CompetititorDropbox
          v-if="
            MarktplaatsData.Competitors && MarktplaatsData.Competitors.length > 0
          "
          :competitorList="MarktplaatsData.Competitors"
          @openCompetitor="openCompetitor"
        />
        <b-button target="_blank" rel="noopener" :href="MarktplaatsData.WebsiteURL">
          <font-awesome-icon
            style="height: 15px; width: 15px"
            :icon="['far', 'external-link']"
          />
          {{ $t("Webportal.CX.Dashboard.Exploration.Marktplaats.MarktplaatsLink")}}
        </b-button>
      </b-button-group>
      
      <template v-if="!isCompetitor">
        <ScoresChart :Scores="MarktplaatsData.OverallScores" :Width="700" v-if="MarktplaatsData.OverallScores"/>
        <hr>

        <table class="table mb-0" v-if="MarktplaatsData.Ratings">
          <tr >
            <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.History") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
          </tr>
          <RatingTableRow
            v-for="item in MarktplaatsData.Ratings"
            :translationPrefix="'Webportal.CX.Dashboard.Exploration.Marktplaats.'"
            :key="item.title"
            :Title="item.RatingTypeName"
            :Ratings="item.RatingTypeResults" />
        </table>
        <hr>
      </template>
      <template v-else>
        <div class="overallscore mb-3">
          <span class="label">{{ $t("Webportal.CX.Exploration.OverallScore")}}</span>
          <span class="value">{{MarktplaatsData.Ratings.find(r => r.Name == 'OverallScore').Value}} <b-icon icon="star-fill" class="text-warning"></b-icon></span>
        </div>


        <table class="table">
          <thead>
            <tr>
              <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
              <th class="border-top-0" colspan="2">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
            </tr>
          </thead>
          <template v-for="rating in MarktplaatsData.Ratings.filter(r => r.Name != 'OverallScore') ">
            <CompetitorRatingTableRow 
              :rating="rating"
              :key="rating.Name"
              :translationPrefix="'Webportal.CX.Dashboard.Exploration.Marktplaats.'"
              />
          </template>
        </table>

        <hr>
      </template>

      <!-- Reviews -->
      <div v-if="Reviews.length <= 0" class="pb-3">
        {{ $t("Webportal.CX.Dashboard.Exploration.NoReviews") }}
      </div>

      <div v-else>
        <p style="color: grey; font-size: 0.9rem">
          {{ ReviewCount }}
          {{ $t("Webportal.CX.Dashboard.Exploration.Reviews") }}
        </p>
        <p>{{ $t("Webportal.CX.Dashboard.Exploration.LatestReviews") }}:</p>
        <div class="pb-4" style="overflow: auto; height: 50%">
          <Accordion
            v-for="(review, index) in Reviews"
            :longText="review.Text"
            :key="index"
            :toggleCols="1"
            class="mb-2"
          >
            <!-- Headline -->
            <b-row slot="short" class="mb-2 pr-0 mr-0" style="width: 110%">
              <b-row
                class="m-0 mb-3 p-0"
                style="
                  font-size: 0.9rem;
                  font-weight: 600;
                  line-height: 1;
                  width: 100%;
                "
              >
                <b-col cols="3">
                </b-col>
                <b-col cols="8">
                  <span>
                    {{ review.AuthorName }}
                  </span>
                </b-col>
              </b-row>

              <!-- First row -->
              <b-row style="width: 110%">
                <!-- Review rating: Overall Score -->
                <b-col cols="3">
                  <b-form-rating
                    variant="warning"
                    class="m-0 p-0"
                    no-border
                    readonly
                    size="sm"
                    :value="review.Rating / 2"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-left"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.OverallResult"
                    )
                  }}
                </b-col>

                <!-- Review rating: Service-->
                <b-col
                  cols="3"
                  class="review-right-star-col"
                >
                  <b-form-rating
                    variant="warning"
                    class
                    no-border
                    readonly
                    size="sm"
                    :value="review.Service / 2"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-right"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Marktplaats.Service"
                    )
                  }}
                </b-col>
              </b-row>

              <!-- Second row -->
              <b-row style="width: 110%">
                <!-- Review rating: Expertise -->
                <b-col cols="3">
                  <b-form-rating
                    variant="warning"
                    class="m-0 p-0"
                    no-border
                    readonly
                    size="sm"
                    :value="review.Expertise / 2"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-left"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Marktplaats.Expertise"
                    )
                  }}
                </b-col>

                <!-- Review rating: PriceQuality -->
                <b-col
                  cols="3"
                  class="review-right-star-col"
                  
                >
                  <b-form-rating
                    variant="warning"
                    class
                    no-border
                    readonly
                    size="sm"
                    :value="review.PriceQuality / 2"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-right"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Marktplaats.PriceQuality"
                    )
                  }}
                </b-col>
              </b-row>
            </b-row>
          </Accordion>
        </div>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import Accordion from "../Accordion";
import RatingDistribution from "./RatingDistribution";
import DashboardService from "@/services/DashboardService";
import RatingTableRow from "@/components/CX/ExplorationCard/RatingTableRow";
import CompetititorDropbox from "./CompetitorDropbox";
import ScoresChart from "@/components/CX/ExplorationCard/ScoresChart";

export default {
  name: "MarktplaatsPopup",
  components: {
    Accordion,
    RatingDistribution,
    CompetititorDropbox,
    RatingTableRow,
    ScoresChart
  },
  props: {
    marktplaatsData: {
      type: Object,
      default: () => {}
    },
    headLine: String,
    isCompetitor: Boolean,
    competitorId: Number
  },
  data() {
    return {
      MarktplaatsData: null,
      MarktplaatsLastRating: {},
      isLoading: true
    };
  },

  computed: {
    _() {
      return _;
    },
    ReviewCount: function() {
      return (
        this.RatingsByName?.ReviewCount?.Value || this.Reviews?.length || 0
      );
    },
    Reviews: function() {
      return (
        this.MarktplaatsData?.Reviews ||
        this.MarktplaatsData?.Marktplaats?.Reviews ||
        []
      );
    },
    Ratings: function() {
      return (
        this.MarktplaatsData?.Ratings ||
        this.MarktplaatsData?.Marktplaats?.Ratings ||
        []
      );
    },
    RatingsByName: function() {
      return (
        this.MarktplaatsData?.RatingsByName ||
        this.MarktplaatsData?.Marktplaats?.RatingsByName ||
        {}
      );
    },
    OverallScore: function() {
      return (
        this.MarktplaatsData?.Threshold?.Value ||
        this.RatingsByName?.OverallScore?.Value ||
        0
      );
    },
  },
  created: function() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  mounted: function() {
    if (this.isCompetitor) {
      this.getCompetitor(this.competitorId).then(response => {
        this.MarktplaatsData = response.data;
        if (this.MarktplaatsData.Marktplaats) {
          this.MarktplaatsData.Marktplaats.RatingsByName = _.keyBy(
            this.MarktplaatsData.Marktplaats.Ratings,
            "Name"
          );
        }
      }).finally(() => {
        this.isLoading = false;
      });
    } else {
      this.MarktplaatsData = { ...this.marktplaatsData };
      // use setTimeout() to await next event cycle/finished building
      window.setTimeout(() => {this.isLoading = false}, 0);
    }
  },
  methods: {
    openCompetitor(id) {
      this.$emit("open-competitor", id);
    },
    getCompetitor(competitorId) {
      return DashboardService.getCompetitor(competitorId, { marktplaats: true });
    },
    close() {
      window.removeEventListener('keyup', this.handleKeyUp);
      this.$emit('close');
    },
    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.close();
      }
    },
  }
};
</script>

<style scoped>
.marktplaats-rating {
  /* width: 88%; */
  margin-left: 5px;
  margin-right: 5px;
  color: grey;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(92, 92, 92, 0.2);
}
.review-caption-left {
  margin-left: -5px;
  padding: 0;
}
.review-caption-right {
  margin-left: -10px;
  padding: 0;
}
.review-right-star-col {
  margin: 0 0px 0 -5px;
  padding: 0 15px 0 0;
}
.subcard-title {
  font-size: 1.5rem;
}
#marktplaats-subcard {
  position: fixed !important;
}
</style>
